module.exports = __webpack_public_path__ + "static/img/home-4.0103ded4.jpg";